import type { MouseEvent, ReactNode } from 'react'
import { ArrowUp } from 'lucide-react'
import { cn } from '@/lib/utils'

export const UP_ONE_LEVEL_LABEL = '.. Up one level'

export function UpOneLevelRow({
  onClick,
  onContextMenu,
  disabled = false,
  density = 'list',
  className,
  testId,
  children,
}: {
  onClick: () => void
  onContextMenu?: (event: MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  /** list = a folder list whose parent row is not on screen. Hide at roots. Not for expand-in-place sidebar trees. */
  density?: 'list' | 'tree'
  className?: string
  testId?: string
  children?: ReactNode
}) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      onContextMenu={onContextMenu}
      data-testid={testId}
      className={cn(
        'w-full items-center text-left transition-colors',
        'hover:bg-muted/40 disabled:pointer-events-none disabled:opacity-40',
        density === 'list' &&
          'grid gap-x-3 px-3 py-2.5 border-b border-border/40',
        density === 'tree' && 'flex px-5 py-1.5',
        className,
      )}
    >
      <div className="flex min-w-0 items-center gap-2.5">
        <ArrowUp className="h-4 w-4 flex-none text-muted-foreground" />
        <div className="truncate text-sm text-muted-foreground">{UP_ONE_LEVEL_LABEL}</div>
      </div>
      {children}
    </button>
  )
}
